module.exports = __webpack_public_path__ + "img/YaoPin2.0725b6cb.png";